import { FFBorrower } from "@/models/ExpertState";
import { FFAverageCosts } from "@/models/simulation/FFAverageCosts";
import { FFLiabilies } from "@/models/simulation/FFLiabilies";
import { Utils } from "@/services/utils/BasicUtils";
import EnvironmentService from "@/env/EnvironmentService";

const WARSAW_DISTRICT = {
  id: 178,
  landId: 14,
} as const;

export class FFHousehold {
  borrowers: FFBorrower[] = [
    new FFBorrower(),
  ];

  averageCosts: FFAverageCosts = { car: 0, house: 0, life: 0, other: 0, };
  numberOfAdults: Nullable<number> = null;
  numberOfChildren: Nullable<number> = null;
  numberOfCars: Nullable<number> = null;
  landId: Nullable<number> = EnvironmentService.Environment.isAppDomain().LENDI_PL
    ? WARSAW_DISTRICT.landId
    : null;
  districtId: Nullable<number> = EnvironmentService.Environment.isAppDomain().LENDI_PL
    ? WARSAW_DISTRICT.id
    : null;
  realEstateSize: Nullable<number> = null;
  willingToDeclareCosts: boolean = true;
  hasLiabilities: boolean = false;
  liabilities: FFLiabilies = new FFLiabilies();

  constructor(dto?: Partial<FFHousehold>) {
    if (dto) {
      Utils.assign(this, dto);
    }
  }
}